import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import { parseUserListOptions, parseVMCohortOptions } from '../../utils/parseResponseToOptions';
import AssignVMUserComponent from './component';

class AssignUserVMContainer extends Component {
  constructor() {
    super();
    this.state = {
      userIdColl: [],
      vmCohortColl: [],
      userList: [],
      vmCohortList: [],
      loading: true,
      userLoading: true,
      vmCohortLoading: true
    };
  }
  componentDidMount() {
    this.props.getDataFromAPI(
      '/vendingmachines/vm-cohorts',
      'GET',
      undefined,
      response => {
        this.setState({
          vmCohortList: parseVMCohortOptions(response.list),
          vmCohortLoading: false,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine cohort details');
        this.setState({ loading: false, vmCohortLoading: false });
      }
    );

    this.props.getDataFromAPI(
      '/users/list',
      'GET',
      undefined,
      response => {
        this.setState({ userList: parseUserListOptions(response.list), userLoading: false });
        this.setState({ loading: false });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch user details');
        this.setState({ loading: false, userLoading: false });
      }
    );
  }

  onChangeOfUser = (event, data) => {
    this.setState({ userIdColl: data.value });
  };

  onChangeOfVMCohort = (event, data) => {
    this.setState({ vmCohortColl: data.value });
  };

  handleSubmit = () => {
    // set loading true
    this.setState({ loading: true });

    const { userIdColl, vmCohortColl } = this.state;

    const payload = {
      userIdColl,
      vmCohortColl
    };

    if (!userIdColl.length) {
      this.setState({ loading: false });
      return toastr.error('Invalid', 'Please select user');
    }
    if (!vmCohortColl.length) {
      this.setState({ loading: false });
      return toastr.error('Invalid', 'Please select vending machine cohort');
    }

    this.props.getDataFromAPI(
      '/users/vms',
      'POST',
      payload,
      response => {
        toastr.success('Successful', 'Assigned vending machine cohort to user');
        this.setState({ loading: false });
        return this.props.history.push('/users/list');
      },
      err => {
        this.setState({ loading: false });
        toastr.error('Failed', 'Failed to assign vending machine cohort  to user');
      }
    );
  };

  render() {
    return (
      <AssignVMUserComponent
        onChangeOfUser={this.onChangeOfUser}
        onChangeOfVMCohort={this.onChangeOfVMCohort}
        submitting={this.state.loading}
        handleSubmit={this.handleSubmit}
        vmCohortLoading={this.state.vmCohortLoading}
        userLoading={this.state.userLoading}
        vmCohortList={this.state.vmCohortList}
        userList={this.state.userList}
      />
    );
  }
}

export default withRouter(
  connect(null, {
    getDataFromAPI
  })(AssignUserVMContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/UsersAssignVM/container.jsx